import React from 'react';
import { Box, Container, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: '#580100',
        color: 'white',
        py: { xs: 3, sm: 4 },
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: 1.5, sm: 1 },
          textAlign: 'center'
        }}>
          <Typography 
            variant="body2" 
            component="div" 
            sx={{ 
              color: 'white',
              order: { xs: 1, sm: 0 },
              mb: { xs: 1, sm: 0 }
            }}
          >
            {currentYear}, Andheri Court's Bar Association. All rights reserved.
          </Typography>
          
          <Box 
            sx={{ 
              display: 'flex',
              flexDirection: { xs: 'row', sm: 'row' },
              alignItems: 'center',
              gap: { xs: 2, sm: 1.5 },
              order: { xs: 0, sm: 1 },
              flexWrap: 'wrap',
              justifyContent: 'center'
            }}
          >
            <Link
              component={RouterLink}
              to="/privacy-policy"
              sx={{ 
                textDecoration: 'none', 
                color: 'white',
                fontSize: '0.875rem',
                '&:hover': { 
                  color: 'rgba(255, 255, 255, 0.8)'
                } 
              }}
            >
              Privacy Policy
            </Link>
            <Box 
              component="span" 
              sx={{ 
                color: 'white',
                display: { xs: 'block', sm: 'block' }
              }}
            >
              •
            </Box>
            <Link
              component={RouterLink}
              to="/terms-of-service"
              sx={{ 
                textDecoration: 'none', 
                color: 'white',
                fontSize: '0.875rem',
                '&:hover': { 
                  color: 'rgba(255, 255, 255, 0.8)'
                } 
              }}
            >
              Terms of Service
            </Link>
            <Box 
              component="span" 
              sx={{ 
                color: 'white',
                display: { xs: 'block', sm: 'block' }
              }}
            >
              •
            </Box>
            <Link
              component={RouterLink}
              to="/cookie-policy"
              sx={{ 
                textDecoration: 'none', 
                color: 'white',
                fontSize: '0.875rem',
                '&:hover': { 
                  color: 'rgba(255, 255, 255, 0.8)'
                } 
              }}
            >
              Cookie Policy
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
